module.exports = __webpack_public_path__ + "static/img/Deepsai-智能设计.e6b23cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Deepsai-智能设计.svg
// module id = tbj/
// module chunks = 11